import React from 'react';
import { auth } from './FireBase';

function SiginOutButton() {
    
    const buttonStyle = {
        display: 'inline-block',
        textDecoration: 'none',
        background: '#668ad8',
        color: '#FFF',
        borderBottom: 'solid 0px #627295',
        borderRadius: '20px',
        animation: 'blink 1s infinite',
        fontFamily: 'auto',
        
        
    };
    
    const parentStyle = {
        display: 'flex',
        justifyContent: 'flex-end'  // 左寄せ
    };
    const handleSignOut = async () => {
        try {
            await auth.signOut(); // サインアウトを試みる
            console.log('サインアウト成功');
        } catch (error) {
            console.error('サインアウトに失敗しました:', error);
        }
    };

    return (
        <div style={parentStyle}>
            <button
                style={{ ...buttonStyle }}

                onClick={handleSignOut}>
                <p>Sign out</p>
            </button>


</div>

    );
}

export default SiginOutButton;
